import React from "react";
import { Route, Redirect } from "react-router-dom";

export function AuthRoute({ component: Component, ...rest }) {
  const token = localStorage.getItem("auth_token");

  return (
    <Route
      {...rest}
      render={(props) => {
        if (token) {
          return <Component {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: "/login",
            }}
          />
        );
      }}
    />
  );
}
